export const SkullIcon = () => {
  return (
    <i
      className='material-symbols-skull-outline text-xl m-[2px]'
      style={{ background: 'var(--mui-palette-error-main)' }}
    />
  );
};
